import React, { useMemo } from 'react';
import '../../../styles/service-pages.scss';
import ServiceDetailCards from '../../../components/ServiceDetailCards';
import LatestWorkGrid from '../../../components/LatestWorkGrid';
import Seo from '../../../components/Seo';

const MvpDevelopment = () => {
  const detailItems = useMemo(() => [
    {
      title: 'Approach',
      description:
        "We start with scope definition — getting brutal about what's essential versus what's a nice-to-have for version two. From there it's design and build in parallel: UX flows, visual design, and front-end development moving together rather than sequentially. It's faster, it's tighter, and it means fewer surprises when things move from design to code.",
    },
    {
      title: 'Delivery',
      description:
        "A live, functional MVP: designed, built, tested, and ready to put in front of real users. You'll also receive documentation of design decisions, a component library for future builds, and a clear backlog of 'what comes next' — prioritised by impact, not just loudness.",
    },
    {
      title: 'Results',
      description:
        "MVPs built with design at the core consistently outperform those that bolt it on afterwards. Better first impressions, stronger user retention in early testing, and — when it comes to investor conversations — a product that looks like a real business, not a proof of concept held together with duct tape.",
    },
  ], []);

  return (
    <>
      <Seo 
        title="MVP Development Services | Heretic Studio"
        description="Launch smarter, faster. We help you build a focused, high-impact MVP that validates your idea, attracts users, and sets a strong foundation for future growth."
      />
      <div className="studio-page service-page service-page--mvp-development">
        <div className="studio-hero service-hero">
          <div className="studio-hero__content service-hero__content">
            <h1 className="studio-hero__title service-hero__title">MVP Development</h1>
            <p className="studio-hero__subtitle service-hero__subtitle">Launch faster, learn quicker</p>
          </div>
        </div>

        <section className="section intro service-intro">
          <div className="wrapper grid-display">
            <div className="row">
              <div className="col-12">
                <div className="blur-text blur-text--1 large center-text introtext">
                  High-impact MVP that validates your idea, attracts users, and sets a strong foundation for future growth.
                </div>
              </div>
            </div>
          </div>
        </section>

        <ServiceDetailCards items={detailItems} />

        <LatestWorkGrid />
      </div>
    </>
  );
};

export default MvpDevelopment;
